import {MEDIAACCESS_SECURE_AVATAR_URL} from 'app/urls';

import {SAFE_IMAGES_REGEX} from './strings';

import type {BasicUserSerializedType} from 'sweet-types';

type ImageSizesTypes = 'tiny' | 'small' | 'large' | 'original';

export function getSafeAvatarUrlForUser(
  user: BasicUserSerializedType | null,
  size: ImageSizesTypes
) {
  if (user == null || user.avatar_image == null) {
    return undefined;
  }

  if (!user.avatar_image.match(SAFE_IMAGES_REGEX)) {
    size = 'original';
  }

  return `${getAvatarBaseUrl(user, size)}?v=${encodeURIComponent(
    user.avatar_image
  )}`;
}

export function getAvatarBaseUrl(
  user: BasicUserSerializedType,
  size: ImageSizesTypes
) {
  return `${MEDIAACCESS_SECURE_AVATAR_URL}${user.id}/${size}/`;
}
